import { useTranslation } from "react-i18next";

import { Column, Columns } from "@aviary";
import { useBreakpoints } from "@shared/hooks";
import {
  headerLearnLinks1,
  headerLearnLinks2,
  mobileHeaderLearnLinks,
} from "@unauthenticated/catalog/data/CatalogMenuLinks";

import { DescriptionIconAndLink } from "../../../DescriptionIconAndLink";

const Learn = () => {
  const { t } = useTranslation();
  const { tablet } = useBreakpoints();
  const isMobile = tablet.lessThan;

  const renderContent = () => {
    if (isMobile) {
      return (
        <Columns>
          <Column columnWidth={6}>
            {mobileHeaderLearnLinks.map(item => (
              <DescriptionIconAndLink
                key={item.key}
                title={t(item.title)}
                description={t(item.description)}
                icon={item.icon}
                link={item.link}
              />
            ))}
          </Column>
        </Columns>
      );
    }

    return (
      <Columns>
        <Column columnWidth={6}>
          {headerLearnLinks1.map(item => (
            <DescriptionIconAndLink
              key={item.key}
              title={t(item.title)}
              description={t(item.description)}
              icon={item.icon}
              link={item.link}
            />
          ))}
        </Column>
        <Column columnWidth={6}>
          {headerLearnLinks2.map(item => (
            <DescriptionIconAndLink
              key={item.key}
              title={t(item.title)}
              description={t(item.description)}
              icon={item.icon}
              link={item.link}
            />
          ))}
        </Column>
      </Columns>
    );
  };

  return renderContent();
};

export { Learn };
